<main class="schedule-page">
  <section class="panel schedule-details">
    <h1>Select Schedule Details</h1>
    <div class="form-grid">
      <label
        ><span>Type <b>*</b></span
        ><select
          [value]="selectionType()"
          (change)="changeSelectionType($any($event.target).value)"
        >
          <option value="QCA">QCA</option>
          <option value="Generator">Generator</option>
        </select></label
      >
      @if (selectionType() === "QCA") {
        <label
          ><span>QCA <b>*</b></span
          ><select
            [value]="selectedQcaId()"
            (change)="changeQca($any($event.target).value)"
          >
            @for (qca of qcas; track qca.qca_id) {
              <option [value]="qca.qca_id">{{ qca.name }}</option>
            }
          </select></label
        >
      } @else {
        <label
          ><span>Generator <b>*</b></span
        ><select
          [value]="selectedGeneratorId()"
          (change)="changeGenerator($any($event.target).value)"
        >
          @for (generator of generators; track generator.generator_id) {
            <option [value]="generator.generator_id">
              {{ generator.name }}
            </option>
          }
        </select></label
        >
      }
      <label
        ><span>Unit <b>*</b></span
        ><select
          [value]="selectedUnitId() ?? ''"
          (change)="changeUnit($any($event.target).value)"
        >
          <option value="">All generator units</option>
          @for (unit of units(); track unit.unit_id) {
            <option [value]="unit.unit_id">
              {{ unit.unit_name }} ({{ unit.rated_capacity_mw }} MW)
            </option>
          }
        </select></label
      >
      <label
        ><span>Schedule Type <b>*</b></span
        ><select
          [value]="scheduleType()"
          (change)="scheduleType.set($any($event.target).value)"
        >
          <option>Day Ahead</option>
          <option>Intraday </option>
          <option>Weekday</option>
        </select></label
      >
      <label
        ><span>Schedule Date <b>*</b></span
        ><input
          type="date"
          [value]="scheduleDate()"
          (change)="scheduleDate.set($any($event.target).value)"
      /></label>
    </div>
    <p class="info">
      <span>ⓘ</span> Please upload the schedule file in Excel format (.xlsx).
      The file should contain 96 time blocks (15-minute interval).
    </p>
  </section>

  @if (selectedUnitId() !== null && selectionType() === "Generator" && selectedGenerator(); as generator) {
    <section class="panel generator-section">
      <h2><span class="success-dot">✓</span> Selected Generator Details</h2>
      <div class="detail-grid">
        <article class="generator-card">
          <div class="plant-image" aria-hidden="true">☀</div>
          <div class="generator-copy">
            <h3>
              {{ generator.name }} <em>{{ generator.status }}</em>
            </h3>
            <p>{{ generator.type }}</p>
            <dl>
              <dt>♙ Installed Capacity</dt>
              <dd>{{ generator.installed_capacity_mw.toFixed(2) }} MW</dd>
              <dt>♙ Available Capacity (AvC)</dt>
              <dd>{{ availableCapacity().toFixed(2) }} MW</dd>
              <dt>▣ Generator Units</dt>
              <dd>{{ units().length }}</dd>
              <dt>◉ Status</dt>
              <dd><mark>Active</mark></dd>
            </dl>
          </div>
        </article>
        <article class="detail-card detail-card--blue">
          <h3><span>▣</span> PSS Details</h3>
          <dl>
            <dt>PSS Name</dt>
            <dd>{{ pss()?.name || "Not linked" }}</dd>
            <dt>PSS Code</dt>
            <dd>{{ pss()?.code || "-" }}</dd>
            <dt>Voltage Level</dt>
            <dd>{{ pss()?.voltage_kv || "-" }} kV</dd>
            <dt>Installed Capacity</dt>
            <dd>{{ pss()?.installed_capacity_mw || "-" }} MW</dd>
            <dt>State / District</dt>
            <dd>{{ pss()?.state || "-" }} / {{ pss()?.district || "-" }}</dd>
          </dl>
          <button type="button">View PSS Details <span>→</span></button>
        </article>
        <article class="detail-card detail-card--green">
          <h3><span>♧</span> QCA Details</h3>
          <dl>
            <dt>QCA Name</dt>
            <dd>{{ displayedQca()?.name || "Not linked" }}</dd>
            <dt>QCA Code</dt>
            <dd>{{ displayedQca()?.code || "-" }}</dd>
            <dt>State</dt>
            <dd>{{ displayedQca()?.state || "-" }}</dd>
            <dt>Registered On</dt>
            <dd>12-Jan-2025</dd>
          </dl>
          <button type="button">View QCA Details <span>→</span></button>
        </article>
        <article class="detail-card detail-card--purple">
          <h3><span>▤</span> Quick Summary</h3>
          <dl>
            <dt>♙ Total Units</dt>
            <dd>{{ units().length }}</dd>
            <dt>♙ Total Capacity</dt>
            <dd>{{ generator.installed_capacity_mw.toFixed(2) }} MW</dd>
            <dt>▤ Total Contracts</dt>
            <dd>{{ contracts().length }}</dd>
            <dt>♙ Contracted Capacity</dt>
            <dd>{{ contractedCapacity().toFixed(2) }} MW</dd>
          </dl>
          <button type="button">View Generator Details <span>→</span></button>
        </article>
      </div>
    </section>
  } @else if (selectedUnitId() !== null && selectionType() === "QCA" && selectedQca(); as qca) {
    <section class="panel generator-section">
      <h2><span class="success-dot">✓</span> Selected QCA Details</h2>
      <div class="detail-grid">
        <article class="detail-card detail-card--green">
          <h3><span>♧</span> QCA Details</h3>
          <dl>
            <dt>QCA Name</dt>
            <dd>{{ qca.name }}</dd>
            <dt>QCA Code</dt>
            <dd>{{ qca.code }}</dd>
            <dt>State</dt>
            <dd>{{ qca.state }}</dd>
            <dt>Status</dt>
            <dd><mark>{{ qca.status }}</mark></dd>
          </dl>
        </article>
      </div>
    </section>
  }

  @if (selectedUnitId() !== null) {
  <section class="panel upload-section">
    <h2>Upload Schedule File</h2>
    <div
      class="upload-zone"
      [class.dragging]="dragActive()"
      (dragover)="$event.preventDefault(); dragActive.set(true)"
      (dragleave)="dragActive.set(false)"
      (drop)="dropFile($event)"
    >
      <div class="drop-copy">
        <span class="cloud-icon">☁</span
        ><strong>Drag and drop your Excel file here</strong><small>or</small
        ><label class="choose-file app-button app-button--secondary"
          >Choose File<input
            type="file"
            accept=".xlsx"
            (change)="selectFile($event)" /></label
        ><small>Only .xlsx files are allowed. Max file size: 10 MB</small>
      </div>
      <div class="file-preview">
        <div class="file-preview__title">
          <strong>Selected File</strong
          ><button
            type="button"
            class="download-template app-button app-button--secondary"
            (click)="downloadTemplate()"
          >
            ⇩&nbsp; Download Template
          </button>
        </div>
        @if (selectedFile(); as file) {
          <div class="file-row">
            <span class="excel-icon">▧</span>
            <div>
              <b>{{ file.name }}</b
              ><small
                >Uploaded on: {{ scheduleDate() }} &nbsp;|&nbsp; Size:
                {{ formatSize(file.size) }}</small
              >
            </div>
            <i>✓</i
            ><button
              type="button"
              class="preview-file"
              (click)="openFilePreview()"
            >
              Preview
            </button>
            ><button
              type="button"
              (click)="clearFile()"
              aria-label="Remove file"
            >
              ♜
            </button>
          </div>
        } @else {
          <p>
            Download the template, complete all 96 blocks, then select your
            file.
          </p>
        }
      </div>
    </div>
    @if (message(); as notice) {
      <p class="message" [class.error]="notice.error">{{ notice.text }}</p>
    }
    <div class="actions">
      <button type="button" class="cancel app-button app-button--secondary" (click)="clearFile()">Cancel</button
      ><button type="button" class="submit app-button app-button--primary" (click)="submit()">
        ⇩&nbsp; Submit
      </button>
    </div>
  </section>
  }
  <p class="note">
    <b>⚠ &nbsp;Note:</b> After submission, the file will be validated and you
    will receive a confirmation message. You can track the status in Schedule
    Monitoring.
  </p>
</main>

@if (isFilePreviewOpen() && selectedFile(); as file) {
  <div class="file-preview-backdrop" role="presentation" (click)="closeFilePreview()">
    <section
      class="file-preview-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="file-preview-title"
      (click)="$event.stopPropagation()"
    >
      <header>
        <div>
          <h2 id="file-preview-title">Schedule File Preview</h2>
          <p>{{ file.name }} · {{ formatSize(file.size) }}</p>
        </div>
        <button type="button" (click)="closeFilePreview()" aria-label="Close file preview">×</button>
      </header>
      <div class="preview-table-wrap">
        <table>
          <thead>
            <tr><th>Block No</th><th>Time</th><th>Schedule (MW)</th><th>Available Capacity (MW)</th></tr>
          </thead>
          <tbody>
            @for (block of previewBlocks(); track block.blockNo) {
              <tr>
                <td>{{ block.blockNo }}</td>
                <td>{{ block.time }}</td>
                <td>{{ block.scheduleMw ?? '-' }}</td>
                <td>{{ block.availableCapacityMw ?? '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <footer>
        <button type="button" class="app-button app-button--secondary" (click)="closeFilePreview()">Back</button>
        <button type="button" class="app-button app-button--primary" (click)="closeFilePreview()">Ready to Save</button>
      </footer>
    </section>
  </div>
}
